module.exports = __webpack_public_path__ + "static/media/mnf-house.64545fe7.png";